import { render } from "./SavedMarker.vue?vue&type=template&id=5ce4fc35&scoped=true"
import script from "./SavedMarker.vue?vue&type=script&lang=js"
export * from "./SavedMarker.vue?vue&type=script&lang=js"

import "./SavedMarker.vue?vue&type=style&index=0&id=5ce4fc35&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce4fc35"]])

export default __exports__